import React from "react";
import "../InvestmentPage/InvestmentSection.css";
import AboutImage from "../../Image/FPOImgae/HappeningKPO.png";

export default function KnowledgeSection() {
  return (
    <section className="fpo-excellence-section">
      <div className="fpo-excellence-container">

        {/* LEFT – IMAGE */}
        <div className="fpo-excellence-col fpo-excellence-left">
          <div className="fpo-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Financial Process Outsourcing"
              className="fpo-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="fpo-excellence-col fpo-excellence-right">
          <div className="fpo-excellence-content">

            <h2 className="fpo-excellence-title">
            The Most Innovative Things Happening With KPO
            </h2>

            <p className="fpo-excellence-text">
              There are three main cases in which companies might benefit greatly from knowledge process outsourcing (KPO).

Disparate skill sets are the first. Someone on their teams could not have sufficient expertise in a certain data type. That, or they just don’t know how to analyse data. Although the team may have 1 or 2 experts working on it, they will need more people to complete the assignment successfully.
The second issue is, as we’ve already indicated, a deficiency of workers. Businesses may want extra assistance because their current personnel is either underqualified or overworked. This is an extremely common justification among self-funded start-ups.
The third factor is inadequate means. That might be because teams are already stretched thin, the KPO process is on the clock, or companies don’t have the capital to hire full-time workers. When compared to the expense of recruiting a full-time employee, the time and effort involved in bringing on a temporary worker or a partner is far smaller.
            </p>

            {/* SERVICES LIST */}
            <ul className="fpo-excellence-list">
            

            </ul>

          </div>
        </div>

      </div>
      <p>Due to the cheap rates compared to in-house alternatives and their short-term involvement in the project, Densat Knowledge Process Outsourcing provides less financial risk for its clients.

As the name implies, knowledge process outsourcing entails outsourcing tasks that need specialised, in-depth knowledge to trained professionals.
When there is a need for specific knowledge and skills but not enough in-house specialists, businesses turn to KPO.
In an ideal world, businesses would use KPO to get a highly qualified staff at a reduced cost.
By developing new procedures or improving productivity, Densat Knowledge Process Outsourcingmay help businesses cut down on operating and production expenses. When there is a shortage of qualified workers, It may help fill the need. Additionally, It allows for the reallocation of resources, including managerial time, to be put toward other tasks, hence increasing output and efficiency.

Because of the adaptability that comes with our Knowledge Process Outsourcing, businesses may quickly and easily add or remove employees as needed. If, for instance, economic circumstances deteriorate, a firm wants to minimise expenses, it may simply downsize its team. Contrarily, if a business wants to increase earnings or income, it may swiftly employ highly skilled workers. Our Team makes businesses more flexible, allowing them to respond quickly to changes in the market and the competition.

Services:-
Knowledge Process Outsourcing, KPO Companies, KPO Services, KPO Process, KPO And BP</p>
    </section>
  );
}
